import { createRouter, createWebHistory } from "vue-router";
import MarketingLayout from "@/views/MarketingLayout.vue";
import { beforeEachLegacy } from "./legacy";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            component: MarketingLayout,
            children: [
                {
                    path: "",
                    name: "home",
                    component: () => import("@/views/HomeView.vue"),
                },
                {
                    path: "gallery",
                    name: "gallery",
                    component: () => import("@/views/GalleryView.vue"),
                },
                {
                    path: "updates",
                    name: "updates",
                    component: () => import("@/views/UpdatesView.vue"),
                },
                {
                    path: "help",
                    name: "help",
                    component: () => import("@/views/HelpView.vue"),
                },
                {
                    path: "help/:slug",
                    name: "help-article",
                    component: () => import("@/views/HelpArticleView.vue"),
                    props: true,
                },
                {
                    path: "operation",
                    name: "operation",
                    component: () => import("@/views/OperationView.vue"),
                },
                {
                    path: "contacts",
                    name: "contacts",
                    component: () => import("@/views/ContactsView.vue"),
                },
                {
                    path: "legacy",
                    name: "legacy",
                    component: () => import("@/views/LegacyView.vue"),
                },
            ],
        },
    ],
    scrollBehavior() {
        return { top: 0, behavior: "smooth" };
    },
});

router.beforeEach(beforeEachLegacy);

export default router;
